import React from "react";
import { Link } from "@inertiajs/react";
import styled from "styled-components";
import { brand_orange_deep, outerContainerCss } from "../../constants/styles";

// Materi Lainnya — related courses carousel-grid. Reuses the homepage
// Sertifikasi card visual (gradient thumb + orange title) but routes
// clicks via Inertia <Link> to `/sertifikasi/:course_slug`.
function RelatedCourses({ courses = [], title = "Materi Lainnya" }) {
  if (!courses.length) return null;
  return (
    <Section aria-labelledby="related-courses">
      <Inner>
        <Heading id="related-courses">{title}</Heading>
        <Grid>
          {courses.map((c) => (
            <Card key={c.id} href={c.detail_url}>
              <Thumb>
                {c.banner_image_url ? (
                  <ThumbImg
                    src={c.banner_image_url}
                    alt={c.name}
                    loading="lazy"
                  />
                ) : (
                  <ThumbPlaceholder aria-hidden="true">
                    {c.name?.[0] || "S"}
                  </ThumbPlaceholder>
                )}
              </Thumb>
              <CardTitle>{c.name}</CardTitle>
              {c.description && <CardSubtitle>{c.description}</CardSubtitle>}
            </Card>
          ))}
        </Grid>
      </Inner>
    </Section>
  );
}

export default React.memo(RelatedCourses);

const Section = styled.section`
  background: #fffaf3;
  padding: 48px 0;
  [data-theme="dark"] & {
    background: rgba(255, 255, 255, 0.02);
  }
`;

const Inner = styled.div`
  ${outerContainerCss}
`;

const Heading = styled.h2`
  font-size: 22px;
  font-weight: 800;
  margin: 0 0 18px;
  color: #1f2937;
  [data-theme="dark"] & {
    color: #f3f4f6;
  }
`;

const Grid = styled.div`
  display: grid;
  /* auto-fit so 3 cards span the row at 1440 without an empty 4th cell,
   * and gracefully reflows to 2/1 columns at narrower widths. The 220px
   * min keeps each card readable.
   */
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 18px;
`;

const Card = styled(Link)`
  display: flex;
  flex-direction: column;
  gap: 8px;
  text-decoration: none;
  color: inherit;
  transition: transform 200ms ease;

  &:hover {
    transform: translateY(-4px);
  }
`;

const Thumb = styled.div`
  aspect-ratio: 16 / 10;
  border-radius: 12px;
  background:
    radial-gradient(
      ellipse at 30% 30%,
      rgba(255, 255, 255, 0.6),
      transparent 55%
    ),
    linear-gradient(135deg, #e5e7eb, #cbd5e1);
  position: relative;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
`;

const ThumbImg = styled.img`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`;

const ThumbPlaceholder = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 48px;
  font-weight: 800;
  color: rgba(255, 255, 255, 0.85);
`;

const CardTitle = styled.div`
  color: ${brand_orange_deep};
  font-weight: 700;
  font-size: 15px;
`;

const CardSubtitle = styled.div`
  color: #6b7280;
  font-size: 12px;
  line-height: 1.5;
  [data-theme="dark"] & {
    color: #d1d5db;
  }
`;
